{
  "title": "Activity Tracking Filters",
  "tooltip": "These filters exclude FBOs and users from activity reports and metrics.",
  "unknown": "Unknown",
  "testFBOs": {
    "sectionTitle": "Test/Demo FBOs",
    "addButton": "Add Test FBO",
    "columns": {
      "fboName": "FBO Name",
      "reason": "Reason",
      "actions": "Actions"
    },
    "deleteButton": "Delete",
    "dialog": {
      "title": "Add Test/Demo FBO",
      "selectFboLabel": "Select FBO",
      "reasonLabel": "Reason (optional)",
      "reasonPlaceholder": "e.g., Internal testing account",
      "cancelButton": "Cancel",
      "addButton": "Add"
    }
  },
  "employees": {
    "sectionTitle": "AirPlx Employees",
    "addButton": "Add Employee",
    "autoExcludedChip": "*@airplx.com (auto-excluded)",
    "emptyState": "No additional employees configured (all @airplx.com emails are automatically excluded)",
    "dialog": {
      "title": "Add AirPlx Employee",
      "emailLabel": "Email Address",
      "emailPlaceholder": "user@example.com",
      "cancelButton": "Cancel",
      "addButton": "Add"
    }
  }
}
